import * as React from 'react';
import Header from './Header';
import SideNavigation from './SideNavigation';
import store, { RootState, useAppSelector } from '../redux/store';
import { setAccordion, setCommonMenu } from '../redux/commonSlice';
import { IconButton } from '@mui/material';

interface Props {
  children?: JSX.Element | JSX.Element[];
}

export default function PageLayout(props: Props) {
  const { children } = props;
  const { menu } = useAppSelector((state: RootState) => state.common);
  return (
    <div className="dashboardWrapper">
      <Header />
      <div className={`sidebar ${menu ? 'menuOpen' : ''}`}>
        <SideNavigation />

        <IconButton
          className="close-menu"
          onClick={() => {
            store.dispatch(setCommonMenu(false));
            store.dispatch(setAccordion(false));
            document.body.classList.remove('body-freeze');
          }}
        >
          <i className="close-icon"></i>
        </IconButton>
      </div>
      <div className={`pageContainer ${menu ? 'menuOpen' : ''}`}>
        {children}
      </div>
      {/* <Footer /> */}
      <div
        className={`navigationOverlay ${menu ? 'overlayShow' : ''}`}
        onClick={() => {
          store.dispatch(setCommonMenu(false));
          store.dispatch(setAccordion(false));
          document.body.classList.remove('body-freeze');
        }}
      ></div>
    </div>
  );
}
